import type { ListBuilderList } from '../../../types';
import { createTripColumnsWithDate } from '../columns';

/**
 * In Progress Routes list configuration
 * Shows routes currently in progress
 */
export const inProgressTripsList: ListBuilderList = {
	id: 'in-progress-trips',
	name: 'In Progress',
	type: 'default',
	active: true,
	cacheTTL: 600000,
	filterRules: {
		routeStatus: {
			defaultValue: [{ id: 'in-progress', label: 'In Progress' }],
		},
	},
	columns: createTripColumnsWithDate(),
	defaultSortId: 'date-desc',
	sortOrder: 3,
};
